import React from "react";
import { CheckCircle2 } from "lucide-react";

const LORA = { fontFamily: "'Lora', Georgia, serif" };

export function ChecklistProgress({ done, total, pct }) {
  return (
    <div
      className="mb-5 p-4 border border-[#DCD4C6] bg-white"
      style={{ borderRadius: "3px" }}
    >
      <div className="flex items-center justify-between mb-2.5">
        <span className="text-xs uppercase tracking-widest text-[#8B5E34]" style={LORA}>
          Progression globale
        </span>
        {pct === 100 ? (
          <span
            className="flex items-center gap-1.5 text-xs font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-2.5 py-1 rounded-full"
            style={LORA}
            data-testid="checklist-done-badge"
          >
            <CheckCircle2 size={12} strokeWidth={2.5} />
            Tout est prêt !
          </span>
        ) : (
          <span
            className="text-sm font-semibold"
            style={{ ...LORA, color: "#C17F59" }}
            data-testid="checklist-pct"
          >
            {pct} %
          </span>
        )}
      </div>
      <div className="h-2.5 rounded-full overflow-hidden" style={{ background: "#F1EBE1" }}>
        <div
          className="h-full rounded-full transition-all duration-700 ease-out"
          style={{
            width: `${pct}%`,
            background: pct === 100 ? "#16A34A" : "#C17F59",
          }}
          data-testid="checklist-progress-bar"
        />
      </div>
      <p className="text-xs text-[#9A8F86] mt-1.5 text-right" style={LORA}>
        {done} / {total} éléments cochés
      </p>
    </div>
  );
}
